/**
 * 活动管理模块
 */

// 引入工具函数
import req from '@/utils/request'

// 获取活动可参与门店列表
export const getComboDeptList = (params) => {
  return req.get('/marketing/combSale/queryDepts', params);
}

// 获取活动可参与医生列表
export const getComboDoctorList = (params) => {
  return req.get('/marketing/combSale/queryDoctors', params);
}

// 获取活动可参与药品/理疗列表
export const getComboDrugList = (params) => {
  return req.get('/marketing/combSale/queryDrugKinds', params);
}

// 获取套餐活动状态数量
export const getComboStatusCount = (params) => {
  return req.get('/marketing/combSale/queryCombSaleStatusCount', params);
}

// 获取套餐活动列表
export const getComboSaleList = (params) => {
  return req.get('/marketing/combSale/queryCombSaleList', params);
}

// 获取套餐活动详情
export const getComboSaleInfo = (params) => {
  return req.get('/marketing/combSale/queryComSaleDetail', params);
}

// 编辑套餐活动
export const postComboSale = (params) => {
  return req.post('/marketing/combSale/addOrEditCombSale', params);
}

// 删除套餐活动
export const deleteCombSale = (params) => {
  return req.get('/marketing/combSale/deleteCombSale', params);
}

// 查询理疗商品参与的进行中活动
export const getProgressPhysioComboList = (params) => {
  return req.get('/marketing/combSale/queryInProgressPhysioCombSales', params);
}

// 查询可使用的进行中套餐活动
export const getCombSaleOpdList = (params) => {
  return req.get('/marketing/combSale/queryCombSaleOpdList', params);
}

// 门诊保存套餐活动
export const postCombSaleSelect = (params) => {
  return req.post('/caseProjectRecipe/packageSelect', params);
}

// 门诊删除套餐活动
export const deleteCombSaleSelect = (params) => {
  return req.get('/caseProjectRecipe/deletePackageSelect', params);
}

// 保存多品活动
export const saveMultipleActivity = (params) => {
  return req.get('/activity/saveMultipleActivity', params);
}

// 取消多品活动
export const cannelMultipleActivity = (params) => {
  return req.get('/activity/cancelMultipleActivity', params);
}